import type { RecursivePartial } from '#types/utils'
import type { ChangeStoreConfirmationConfig } from '#types/config/components/dialog/changeStoreConfirmation'

export default {
  editLocationButtonVariant: 'secondary',
} satisfies RecursivePartial<ChangeStoreConfirmationConfig>
